import React from 'react'
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

import "./ServicesList.css";

import Email from "../../images/email.svg";
import Tele from "../../images/phone-call.svg";


function ServicesList(props) {
    const data = props;

    return (
        <div className="sv-sticky-container block w-full md:w-1/3 pr-0 md:pr-8 order-2 md:order-1">
            <div className="sc-navigation">
                {data.list.map((cat, index) => (
                    <div key={`nav-cat-${index}`} className={index > 0 ? "mt-8" : "mt-0"}>
                        <ul>
                            {cat.node.services && cat.node.services.edges.map((service, yndex) => (
                                <li key={`nav-serv-${yndex}`} className="sv-li" style={data.currentPage === service.node.uri ? { color: "#ffc329" } : { color: "inherit" }}>
                                    <Link to={service.node.uri} >
                                        {service.node.title}
                                    </Link>
                                </li>
                            ))}

                            {cat.node.projects && cat.node.projects.edges.map((service, yndex) => (
                                <li key={`nav-serv-${yndex}`} className="sv-li" style={data.currentPage === service.node.uri ? { color: "#ffc329" } : { color: "inherit" }}>
                                    <Link to={service.node.uri} >
                                        {service.node.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ServicesList;